import { stringify } from 'query-string';
import DefaultMapper, { toPagingAndSorting } from '../../dataProvider/DefaultMapper';
import { API_BASE_PATH_ADMIN } from '../../constants';

class BlackWhiteListItemMapper extends DefaultMapper {
	mapResource({ resource }) {
		return 'system/blackwhitelists/items';
	}

	prepareGetList({ type, resource, params, options, mappedResource }) {
		const query = {
			...toPagingAndSorting(params),
			blackWhiteListId: params.filter.blackWhiteListId
		};
		options.url = `${API_BASE_PATH_ADMIN}/${mappedResource}?${stringify(query)}`;
	}

	prepareCreate({ type, resource, params, options, mappedResource }) {
		options.url = `${API_BASE_PATH_ADMIN}/system/blackwhitelists/${params.id}/items`;
		options.method = 'POST';
		options.body = JSON.stringify(params.data);
	}

	prepareUpdate({ params, options }) {
		options.url = `${API_BASE_PATH_ADMIN}/system/blackwhitelists/items/${params.data.id}`;
		options.method = 'PUT';
		const filteredParams = Object.assign({}, params.data);
		delete filteredParams.id;
		delete filteredParams.creationDateTime;
		delete filteredParams.blackWhiteListId;
		options.body = JSON.stringify(filteredParams);
	}
}

export default BlackWhiteListItemMapper;
